export default IconChartAreaLine => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-chart-area-line" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M4 19l4 -6l4 2l4 -5l4 4l0 5l-16 0" />
  <path d="M4 12l3 -4l4 2l5 -6l4 4" />
</svg>`;